import { AwsComponentKey } from "@p0security/shared/integrations/resources/aws/types";
import { AzureComponentKey } from "@p0security/shared/integrations/resources/azure/types";
import {
  GcloudIamComponentKey,
  GcloudSecurityPerimeterComponentKey,
} from "@p0security/shared/integrations/resources/gcloud/types";

export const WelcomeFlows = {
  JIT: "jit",
  ASSESSMENT: "assessment",
} as const;

export type SupportedCloudProviders = "aws" | "azure" | "gcloud";

export type CloudProviderParams = {
  cloudProvider: SupportedCloudProviders;
  component:
    | AwsComponentKey
    | AzureComponentKey
    | GcloudIamComponentKey
    | GcloudSecurityPerimeterComponentKey;
} & (
  | {
      cloudProvider: "aws";
      component: AwsComponentKey;
    }
  | {
      cloudProvider: "azure";
      component: AzureComponentKey;
    }
  | {
      cloudProvider: "gcloud";
      component: GcloudIamComponentKey | GcloudSecurityPerimeterComponentKey;
    }
);
